// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"982fc37e","338":"d41492ea","503":"bab5466e","787":"cacff31e"}[chunkId] + ".chunk.js";
};